/**
 * @fileoverview <a>ボタン(ダウンロード等で使用)のコンポーネント
 */

/**
 * @typedef <a>ボタンのプロパティ
 * @property {string} href - ボタンのリンク先URL
 * @property {string} text - ボタンのテキスト
 * @property {boolean} [download] - ダウンロード属性
 */
interface AtagButtonProps {
  href: string;
  text: string;
  download?: boolean;
}

/**
 * <a>ボタンのコンポーネント
 * @param {AtagButtonProps} props - プロパティ
 * @returns {JSX.Element} <a>ボタンのJSX要素
 */
const AtagButton: React.FC<AtagButtonProps> = ({ href, text, download }) => {
  return (
    <div className="c-wrapper c-wrapper--close-btn u-mt-30">
      <a
        href={href}
        className="c-btn c-btn--default c-btn--block"
        download={download ? "" : undefined}
      >
        {text}
      </a>
    </div>
  );
};
export default AtagButton;
